import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';

export default function topHeaderReducer(state = initialstate.topHeader, action) {
	switch (action.type) {
		case types.GET_TOP_ENTITY_METADATA:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return {
                    ...state,
                    entityMetadata: action.mapper(action.response)
                };
			}
			return state;
		default:
			return state;
	}
}
